<template>
  <footer class="footer">
    <span>&copy; 2024 北京易才人力资源顾问有限公司</span>
    <span class="footer-contact">地址：北京市朝阳区建国路56号天洋运河壹号F1栋301室
      <!-- <span class="footer-phone">电话：010-57234683</span> -->
    </span>
    <span> <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2022022158号-5</a> </span>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  height: 131px;
  font-size: 12px;
  line-height: 17px;
  color: $font-color3;
  background-color: $bg-dark-color;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .footer-contact{
    text-align: center;
  }
  .footer-phone {
    margin-left: 2em;
    @media screen and (max-width: 900px) {
      display: inline-block;
    }
  }
}
</style>

